// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'expression';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round'>
    <path d='M5.5 2C3.824 2 3.824 3 3.824 5.277v.297C3.824 7.957 3.497 8.924 1 9m4.5 7c-1.676 0-1.676-1-1.676-3.277v-.297C3.824 10.043 3.497 9.076 1 9m11.5-7c1.676 0 1.676 1 1.676 3.277v.297c0 2.383.326 3.35 2.824 3.426' />
    <path d='M12.5 16c1.676 0 1.676-1 1.676-3.277v-.297c0-2.383.326-3.35 2.824-3.426' />
  </g>
);

export const viewBox = '0 0 18 18';
